module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5296"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c12_r1#d7e3",
      "id": "d6e3"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("1 ")])])], 1), _c('b', [_vm._v("So You Want to Be a Ghost Hunter")])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e5826"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c13_r1#d7e4",
      "id": "d6e4",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("2 ")])])], 1), _c('b', [_vm._v("Manifesting Through Time")])], 1)]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e6396"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c14_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("3 ")])])], 1), _c('b', [_vm._v("The Psychic Skill Set")])], 1)]), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e6896"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c15_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("4 ")])])], 1), _c('b', [_vm._v("Are They Kindred Spirits? ")])], 1)]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7447"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c16_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("5 ")])])], 1), _c('b', [_vm._v("Playing Psychic Detective")])], 1)]), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7907"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c17_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("6 ")])])], 1), _c('b', [_vm._v("Psychic Practice Makes Perfect ")])], 1)]), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8347"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c18_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("7 ")])])], 1), _c('b', [_vm._v("Who Ya Gonna Call? ")])], 1)]), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8937"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("8 ")])])], 1), _c('b', [_vm._v("Paranormal Investigation Gear ")])], 1)]), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9627"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c20_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("9 ")])])], 1), _c('b', [_vm._v("Prepping for the Paranormal")])], 1)]), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10177"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c21_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("10 ")])])], 1), _c('b', [_vm._v("Having the Right Spirit")])], 1)]), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10718"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c22_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("11 ")])])], 1), _c('b', [_vm._v("Spectral Sites Surround Us ")])], 1)]), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e11128"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c23_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("12 ")])])], 1), _c('b', [_vm._v("Making the Psychic Connection ")])], 1)]), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e11578"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c24_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("13 ")])])], 1), _c('b', [_vm._v("Ghost Tracking 101 ")])], 1)]), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e12108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c25_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("14 ")])])], 1), _c('b', [_vm._v("I Put a Spell on You ")])], 1)]), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e12518"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c26_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("15 ")])])], 1), _c('b', [_vm._v("Spirit Help and Psychic Shields ")])], 1)]), _vm._v(" "), _vm._m(86), _vm._v(" "), _vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _vm._m(89), _vm._v(" "), _vm._m(90), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e12998"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c27_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("16 ")])])], 1), _c('b', [_vm._v("Is This Really the End? ")])], 1)]), _vm._v(" "), _vm._m(91), _vm._v(" "), _vm._m(92), _vm._v(" "), _vm._m(93), _vm._v(" "), _vm._m(94), _vm._v(" "), _vm._m(95), _vm._v(" "), _vm._m(96), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e13478"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c28_r1#d7e19",
      "id": "d6e19",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("17 ")])])], 1), _c('b', [_vm._v("In the Land of Mundania ")])], 1)]), _vm._v(" "), _vm._m(97), _vm._v(" "), _vm._m(98), _vm._v(" "), _vm._m(99), _vm._v(" "), _vm._m(100), _vm._v(" "), _vm._m(101), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e13929"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7e20",
      "id": "d6e20",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("18 ")])])], 1), _c('b', [_vm._v("Magical Record-Keeping")])], 1)]), _vm._v(" "), _vm._m(102), _vm._v(" "), _vm._m(103), _vm._v(" "), _vm._m(104), _vm._v(" "), _vm._m(105), _vm._v(" "), _vm._m(106), _vm._v(" "), _vm._m(107), _vm._v(" "), _vm._m(108), _vm._v(" "), _vm._m(109), _vm._v(" "), _vm._m(110), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e14659"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c30_r1#d7e21",
      "id": "d6e21",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("19 ")])])], 1), _c('b', [_vm._v("In the Public Domain ")])], 1)]), _vm._v(" "), _vm._m(111), _vm._v(" "), _vm._m(112), _vm._v(" "), _vm._m(113), _vm._v(" "), _vm._m(114), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e15159"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c31_r1#d7e22",
      "id": "d6e22",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('big', [_c('b', [_vm._v("20 ")])])], 1), _c('b', [_vm._v("Foretelling the Future ")])], 1)]), _vm._v(" "), _vm._m(117), _vm._v(" "), _vm._m(118), _vm._v(" "), _vm._m(119), _vm._v(" "), _vm._m(120), _vm._v(" "), _vm._m(121), _vm._v(" "), _vm._m(122), _vm._v(" "), _vm._m(123), _vm._v(" "), _vm._m(124), _vm._v(" "), _vm._m(125), _vm._v(" "), _vm._m(126)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e5086"
    }
  }, [_c('b', [_vm._v("Contents ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5136"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c10_r1#d7e1",
      "id": "d6e1"
    }
  }, [_c('b', [_vm._v("Top Ten Things about Approaching the Paranormal ")]), _c('b', [_vm._v("World ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5216"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c11_r1#d7e2",
      "id": "d6e2"
    }
  }, [_c('b', [_vm._v("Introduction ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5296.1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c12_r1#d7ee1",
      "id": "d6ee1"
    }
  }, [_vm._v("Not for the Faint-Hearted ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5296.2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c12_r1#d7ee2",
      "id": "d6ee2"
    }
  }, [_vm._v("Hobbyist or Professional? ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5296.3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c12_r1#d7ee3",
      "id": "d6ee3"
    }
  }, [_vm._v("Financial Resources and Considerations ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5296.4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c12_r1#d7ee4",
      "id": "d6ee4"
    }
  }, [_vm._v("Observational Skills and Information Gathering ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5296.5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c12_r1#d7ee5",
      "id": "d6ee5"
    }
  }, [_vm._v("Sensitivity to the Supernatural ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5296.6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c12_r1#d7ee6",
      "id": "d6ee6"
    }
  }, [_vm._v("Patience and Reliability Pay Off ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5826.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c13_r1#d7ee7",
      "id": "d6ee7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Ancient Belief in the Afterlife ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5826.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c13_r1#d7ee8",
      "id": "d6ee8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghosts in Ancient Egypt, Greece, and Rome ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5826.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c13_r1#d7ee9",
      "id": "d6ee9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hauntings in Great Britain ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5826.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c13_r1#d7ee10",
      "id": "d6ee10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victorian Ghost Hunters ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5826.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c13_r1#d7ee11",
      "id": "d6ee11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghost Hunting in the Twenty-First Century ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e5826.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c13_r1#d7ee12",
      "id": "d6ee12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Something Out There? ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6396.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c14_r1#d7ee13",
      "id": "d6ee13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cultivating Your Talents ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6396.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c14_r1#d7ee14",
      "id": "d6ee14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychics and Seers ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6396.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c14_r1#d7ee15",
      "id": "d6ee15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Paranormal Self-Education")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6396.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c14_r1#d7ee16",
      "id": "d6ee16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking Specialized Classes ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6396.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c14_r1#d7ee17",
      "id": "d6ee17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instinct Versus Intellect ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6396.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c14_r1#d7ee18",
      "id": "d6ee18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divination, Necromancy, and Dowsing ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6896.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c15_r1#d7ee19",
      "id": "d6ee19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghosts, Apparitions, and Demons ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6896.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c15_r1#d7ee20",
      "id": "d6ee20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ectoplasmic Mists and Fogs ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6896.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c15_r1#d7ee21",
      "id": "d6ee21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poltergeists and Elemental Spirits ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6896.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c15_r1#d7ee22",
      "id": "d6ee22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Residual Hauntings ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6896.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c15_r1#d7ee23",
      "id": "d6ee23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intelligent and Human Hauntings ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6896.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c15_r1#d7ee24",
      "id": "d6ee24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dangerous Entities ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7447.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c16_r1#d7ee25",
      "id": "d6ee25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laying the Groundwork ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7447.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c16_r1#d7ee26",
      "id": "d6ee26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collecting Eyewitness Accounts ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7447.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c16_r1#d7ee27",
      "id": "d6ee27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gathering Background Data")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7447.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c16_r1#d7ee28",
      "id": "d6ee28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Land Data Research Resources ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7447.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c16_r1#d7ee29",
      "id": "d6ee29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Local Sources of Information ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7447.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c16_r1#d7ee30",
      "id": "d6ee30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using the Internet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7907.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c17_r1#d7ee31",
      "id": "d6ee31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Knowledge ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7907.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c17_r1#d7ee32",
      "id": "d6ee32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Commitment ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7907.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c17_r1#d7ee33",
      "id": "d6ee33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghost Team ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7907.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c17_r1#d7ee34",
      "id": "d6ee34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Equipment ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7907.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c17_r1#d7ee35",
      "id": "d6ee35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Resources ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e7907.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c17_r1#d7ee36",
      "id": "d6ee36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Access ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8347.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c18_r1#d7ee37",
      "id": "d6ee37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tech People ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8347.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c18_r1#d7ee38",
      "id": "d6ee38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychics and Mediums ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8347.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c18_r1#d7ee39",
      "id": "d6ee39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Researchers and Investigators")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8347.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c18_r1#d7ee40",
      "id": "d6ee40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clergy and Shamans ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8347.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c18_r1#d7ee41",
      "id": "d6ee41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographers and Videographers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8347.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c18_r1#d7ee42",
      "id": "d6ee42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parapsychologists and Demonologists ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8937.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7ee43",
      "id": "d6ee43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purchasing the Gear ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8937.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7ee44",
      "id": "d6ee44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Video and Still Photography")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8937.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7ee45",
      "id": "d6ee45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Audio Voice Recorders ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8937.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7ee46",
      "id": "d6ee46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thermometers and Chilly Spirits ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8937.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7ee47",
      "id": "d6ee47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infrared Cameras and Motion Sensors")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8937.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7ee48",
      "id": "d6ee48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EMF and ELF Meters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8937.7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7ee49",
      "id": "d6ee49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flashlights, Lanterns, Compasses, and Watches")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8937.8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c19_r1#d7ee50",
      "id": "d6ee50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miscellaneous Equipment ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e9627.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c20_r1#d7ee51",
      "id": "d6ee51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protecting the Client’s Privacy ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e9627.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c20_r1#d7ee52",
      "id": "d6ee52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making an Honest Assessment ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e9627.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c20_r1#d7ee53",
      "id": "d6ee53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Following Scientific Protocols ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e9627.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c20_r1#d7ee54",
      "id": "d6ee54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Integrity and Accountability to Clients ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e9627.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c20_r1#d7ee55",
      "id": "d6ee55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Accountability to Team Members")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e9627.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c20_r1#d7ee56",
      "id": "d6ee56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Follow-Up Investigations ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10177.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c21_r1#d7ee57",
      "id": "d6ee57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interviewing the Witnesses ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10177.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c21_r1#d7ee58",
      "id": "d6ee58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assessing the Threat Level ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10177.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c21_r1#d7ee59",
      "id": "d6ee59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding Site Layout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10177.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c21_r1#d7ee60",
      "id": "d6ee60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mapping Power Sources and Natural Anomalies ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10177.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c21_r1#d7ee61",
      "id": "d6ee61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Educating and Comforting Clients")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10177.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c21_r1#d7ee62",
      "id": "d6ee62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remaining Objective and Professional ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10718.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c22_r1#d7ee63",
      "id": "d6ee63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battlefields and Historic Sites ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10718.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c22_r1#d7ee64",
      "id": "d6ee64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cemeteries and Graveyards ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10718.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c22_r1#d7ee65",
      "id": "d6ee65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schools and Churches ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10718.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c22_r1#d7ee66",
      "id": "d6ee66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theaters and Museums ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e10718.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c22_r1#d7ee67",
      "id": "d6ee67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Private Residences ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11128.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c23_r1#d7ee68",
      "id": "d6ee68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Site Check with the Client ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11128.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c23_r1#d7ee69",
      "id": "d6ee69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Equipment Check and Deployment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11128.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c23_r1#d7ee70",
      "id": "d6ee70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Organizing the Team ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11128.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c23_r1#d7ee71",
      "id": "d6ee71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recording Data and Observations Manually ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11128.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c23_r1#d7ee72",
      "id": "d6ee72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Debunking and Natural Explanations ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11578.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c24_r1#d7ee73",
      "id": "d6ee73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Electronic Voice Phenomena ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11578.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c24_r1#d7ee74",
      "id": "d6ee74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capturing Elusive Images")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11578.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c24_r1#d7ee75",
      "id": "d6ee75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Investigator’s Checklist ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11578.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c24_r1#d7ee76",
      "id": "d6ee76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honing Your Skills ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11578.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c24_r1#d7ee77",
      "id": "d6ee77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note Taking and Observations ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11578.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c24_r1#d7ee78",
      "id": "d6ee78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matrixing Anomalies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12108.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c25_r1#d7ee79",
      "id": "d6ee79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychic Attack ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12108.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c25_r1#d7ee80",
      "id": "d6ee80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physical Attack ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12108.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c25_r1#d7ee81",
      "id": "d6ee81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Client Problems ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12108.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c25_r1#d7ee82",
      "id": "d6ee82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Equipment Failure ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12108.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c25_r1#d7ee83",
      "id": "d6ee83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jinxes and Hexes ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12518.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c26_r1#d7ee84",
      "id": "d6ee84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When the Hunter Becomes the Hunted ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12518.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c26_r1#d7ee85",
      "id": "d6ee85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protection from Psychic Attack ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12518.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c26_r1#d7ee86",
      "id": "d6ee86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protection from Physical Attack")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12518.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c26_r1#d7ee87",
      "id": "d6ee87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Involving Priests and Clergy ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12518.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c26_r1#d7ee88",
      "id": "d6ee88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wards and Shields ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12998.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c27_r1#d7ee89",
      "id": "d6ee89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cleansing Rituals and Closure ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12998.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c27_r1#d7ee90",
      "id": "d6ee90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analyzing the Evidence ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12998.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c27_r1#d7ee91",
      "id": "d6ee91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reviewing Photos and Video ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12998.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c27_r1#d7ee92",
      "id": "d6ee92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVPs and the Ghost Box ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12998.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c27_r1#d7ee93",
      "id": "d6ee93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Showing the Data to the Client ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12998.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c27_r1#d7ee94",
      "id": "d6ee94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Following Up ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13478.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c28_r1#d7ee95",
      "id": "d6ee95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaining Access to Sites ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13478.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c28_r1#d7ee96",
      "id": "d6ee96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Client Release and Permission Forms ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13478.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c28_r1#d7ee97",
      "id": "d6ee97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trespassing Is Illegal ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13478.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c28_r1#d7ee98",
      "id": "d6ee98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medical Information and Preparedness ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13478.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c28_r1#d7ee99",
      "id": "d6ee99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Insurance and Covering Your Assets ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee100",
      "id": "d6ee100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Case Files and the Case Manager ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee101",
      "id": "d6ee101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Request to Conduct Investigation ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee102",
      "id": "d6ee102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permission Forms ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee103",
      "id": "d6ee103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Release Forms ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee104",
      "id": "d6ee104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interview Questionnaires ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee105",
      "id": "d6ee105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Site Investigation Forms")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee106",
      "id": "d6ee106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meticulous Records and Analysis ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee107",
      "id": "d6ee107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CD or DVD Digital Storage ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e13929.9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c29_r1#d7ee108",
      "id": "d6ee108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Member Interview and Assessment ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e14659.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c30_r1#d7ee109",
      "id": "d6ee109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building an Online Presence")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e14659.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c30_r1#d7ee110",
      "id": "d6ee110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Ghost Hunting Website ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e14659.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c30_r1#d7ee111",
      "id": "d6ee111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Networking in the Community")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e14659.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c30_r1#d7ee112",
      "id": "d6ee112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ghost Photo Gallery ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e14659.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c30_r1#d7ee113",
      "id": "d6ee113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helping Those in Trouble ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e14659.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c30_r1#d7ee114",
      "id": "d6ee114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lectures, Presentations, and Classes ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15159.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c31_r1#d7ee115",
      "id": "d6ee115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compiling and Comparing Data ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15159.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c31_r1#d7ee116",
      "id": "d6ee116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Avenues of Research ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15159.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c31_r1#d7ee117",
      "id": "d6ee117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Technology and Tools")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15159.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c31_r1#d7ee118",
      "id": "d6ee118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Ways of Analyzing Information ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15159.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c31_r1#d7ee119",
      "id": "d6ee119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Applying the Scientific Method ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15159.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c31_r1#d7ee120",
      "id": "d6ee120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking New Ground ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15619"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c32_r1#d7e23",
      "id": "d6e23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix A: ")]), _c('b', [_vm._v("Most Haunted Sites in America ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15689"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c33_r1#d7e24",
      "id": "d6e24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix B: ")]), _c('b', [_vm._v("Famous Ghosts ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15769"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c34_r1#d7e25",
      "id": "d6e25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix C: ")]), _c('b', [_vm._v("Glossary ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15839"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Elli_9781605507057_epub_c35_r1#d7e26",
      "id": "d6e26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix D: ")]), _c('b', [_vm._v("Bibliography ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c5b0268","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Elli_9781605507057_epub_c8_r1.vue
// module id = 78
// module chunks = 0